import { Company, Customer } from '@mews-commander/data-access';
import { DropdownItem } from '@optimus-web/core';
import { getFullName } from '@mews-commander/utils';
import { TextKey } from '@mews-commander/enums';
import { DividerAccountListItem } from './DividerAccountListItem';

interface RenderAccountListProps {
    customers: Customer[];
    companies: Company[];
}

export const renderAccountList = ({ customers, companies }: RenderAccountListProps) =>
    [
        customers.length && <DividerAccountListItem key="customer-divider" textKey={TextKey.CustomerPlural} />,
        ...customers.map((customer) => (
            <DropdownItem
                key={`customer-${customer.id}`}
                value={customer.id}
                label={<>{getFullName({ firstName: customer.firstName, lastName: customer.lastName })}</>}
            />
        )),
        companies.length && <DividerAccountListItem key="company-divider" textKey={TextKey.CompanyPlural} />,
        ...companies.map((company) => (
            <DropdownItem key={`company-${company.id}`} value={company.id} label={<>{company.name}</>} />
        )),
    ].filter(Boolean);
